import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, TableHead, TableRow, TableSortLabel } from '@mui/material/';
import { visuallyHidden } from '@mui/utils';
import { StyledCell, } from './style';
import { useTypedTheme } from '@monorepo-web/styles';
export var AlignTypes;
(function (AlignTypes) {
    AlignTypes["center"] = "center";
    AlignTypes["left"] = "left";
    AlignTypes["right"] = "right";
})(AlignTypes || (AlignTypes = {}));
export default function EnhancedTableHead({ columns, onRequestSort, order, orderBy, fontSize, }) {
    const theme = useTypedTheme();
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };
    return (_jsx(TableHead, { children: _jsx(TableRow, { children: columns.map((column, i) => {
                var _a, _b, _c, _d;
                const align = (_a = column.headerAlign) !== null && _a !== void 0 ? _a : column.align;
                return (_jsx(StyledCell, Object.assign({ style: { padding: '6px 8px' }, "$borderRight": column.freeze || i === 0, "$freeze": (_b = column.freeze) !== null && _b !== void 0 ? _b : false, "$leftOnFreeze": (_c = column.leftOnFreeze) !== null && _c !== void 0 ? _c : 0, "$zIndex": column.freeze ? 4 : 3, "$paddingLeft": column.freeze && typeof column.colorLegend !== 'undefined' ? true : false, align: align !== null && align !== void 0 ? align : 'left', sortDirection: orderBy === column.id ? order : false, sx: {
                        padding: (_d = column.padding) !== null && _d !== void 0 ? _d : '8px',
                        marginLeft: column.colorLegend ? '16px' : '',
                        borderBottom: column.bgColor ? '0px' : '2px solid #BEBEBE',
                        backgroundColor: column.bgColor ? theme.backgroundColor : 'white',
                        color: theme.titleFontColor,
                        fontWeight: 'bold',
                        fontSize: fontSize !== null && fontSize !== void 0 ? fontSize : 14,
                    } }, { children: (column === null || column === void 0 ? void 0 : column.orderBy) ? (_jsxs(TableSortLabel, Object.assign({ active: orderBy === column.id, direction: orderBy === column.id ? order : 'asc', onClick: createSortHandler(column.id) }, { children: [column.label, orderBy === column.id ? (_jsx(Box, Object.assign({ component: "span", sx: visuallyHidden }, { children: order === 'desc' ? 'sorted descending' : 'sorted ascending' }))) : null] }))) : (column.label) }), column.id));
            }) }) }));
}
